import { Route } from "react-router-dom";
// import ProviderHome from "../components/index";
import ProviderHome from "../../../../Clients/components/client-home/components/index";

const ProviderHomeRoutes = () => (
  <>
    {/* <Route path="/" element={<ProviderHome />} /> */}
    <Route index element={<ProviderHome />} />
  </>
);


export default ProviderHomeRoutes;
